import * as XLSX from 'xlsx'
import { getEmpresaCached } from '@/views/ConfigEmpresa/services/empresa.api'

export async function exportPagosExcel(pagos, { startDate, endDate, filename } = {}) {
  const empresa = await getEmpresaCached().catch(() => null)
  const nombreEmpresa = empresa?.nombre || empresa?.nombre_empresa || 'Gimnasio'
  const ruc = empresa?.ruc ? `RUC: ${empresa.ruc}` : ''

  const headers = ['Socio','Identificación','Email','Membresía','Fecha Pago','Estado','Monto Recibido','Monto Aplicado','Cambio','Método','Observaciones']
  const rows = (pagos || []).map(p => [
    p.usuario?.nombre || '-',
    p.usuario?.identificacion || p.usuario?.cedula || '-',
    p.usuario?.email || '-',
    p.membresia?.nombre || '-',
    p.fecha_pago ? new Date(p.fecha_pago).toLocaleDateString('es-EC') : '-',
    (p.estado || 'confirmado').toUpperCase(),
    Number(p.monto_recibido ?? p.monto_pagado ?? 0).toFixed(2),
    Number(p.monto_pagado ?? 0).toFixed(2),
    Number(p.cambio ?? 0).toFixed(2),
    p.metodo_pago || '-',
    p.observaciones || '-',
  ])

  const wb = XLSX.utils.book_new()
  const wsData = []
  // Título empresa
  wsData.push([nombreEmpresa])
  if (ruc) wsData.push([ruc])
  wsData.push([`Pagos de Membresía ${startDate && endDate ? `(${startDate} al ${endDate})` : ''}`])
  wsData.push([])
  wsData.push(headers)
  rows.forEach(r => wsData.push(r))
  // Totales
  const totalMonto = (pagos || []).reduce((acc,p)=> acc + Number(p.monto_pagado||0),0)
  wsData.push([])
  wsData.push(['','','','','','','',`Total Aplicado:`, totalMonto.toFixed(2)])

  const ws = XLSX.utils.aoa_to_sheet(wsData)

  // Merge título
  ws['!merges'] = [
    { s:{r:0,c:0}, e:{r:0,c:headers.length-1} },
    { s:{r:1,c:0}, e:{r:1,c:headers.length-1} },
    { s:{r:2,c:0}, e:{r:2,c:headers.length-1} },
  ]
  // Anchos
  ws['!cols'] = [
    { wch: 22 },{ wch:16 },{ wch:26 },{ wch:20 },{ wch:14 },{ wch:14 },{ wch:14 },{ wch:14 },{ wch:12 },{ wch:16 },{ wch:28 }
  ]
  // Estilo cabecera simple (negrita se hace via s si se usa xlsx-style, fallback sin estilo)
  XLSX.utils.book_append_sheet(wb, ws, 'Pagos')
  const fname = filename || `pagos_${(startDate||'inicio')}_${(endDate||'fin')}.xlsx`
  XLSX.writeFile(wb, fname)
}

export async function exportPagosSocioExcel(pagos, { socioNombre, filename } = {}) {
  const empresa = await getEmpresaCached().catch(() => null)
  const nombreEmpresa = empresa?.nombre || 'Gimnasio'
  const headers = ['Fecha','Estado','Método','Recibido','Aplicado','Cambio','Observaciones']
  const rows = (pagos||[]).map(p=>[
    p.fecha_pago ? new Date(p.fecha_pago).toISOString().slice(0,10) : '-',
    (p.estado || 'confirmado').toUpperCase(),
    p.metodo_pago || '-',
    Number((p.monto_recibido ?? p.monto_pagado) || 0).toFixed(2),
    Number(p.monto_pagado||0).toFixed(2),
    Number(p.cambio||0).toFixed(2),
    p.observaciones||'-'
  ])
  const wb = XLSX.utils.book_new()
  const wsData = []
  wsData.push([nombreEmpresa])
  wsData.push([`Pagos - ${socioNombre || 'Socio'}`])
  wsData.push([])
  wsData.push(headers)
  rows.forEach(r=>wsData.push(r))
  const ws = XLSX.utils.aoa_to_sheet(wsData)
  ws['!merges'] = [{s:{r:0,c:0},e:{r:0,c:6}},{s:{r:1,c:0},e:{r:1,c:6}}]
  ws['!cols'] = [{wch:14},{wch:14},{wch:16},{wch:12},{wch:12},{wch:12},{wch:30}]
  XLSX.utils.book_append_sheet(wb, ws, 'Pagos Socio')
  XLSX.writeFile(wb, filename || `pagos_socio_${(socioNombre||'').replace(/\s+/g,'_')}.xlsx`)
}
